<template>
  <div class="flex flex-col h-full fixed top-0 left-0 bg-white" v-if="visible">
    <div v-html="policy" class="privacy-policy p-2"></div>
    <div class="flex bg-white py-2" v-if="policy">
      <button class="btn btn-2 mx-1 flex-1" @click="reject()">Annulla</button>
      <button class="btn btn-1 mx-1 flex-1" @click="accept()">Accetta</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      policy: null
    }
  },

  async mounted() {
    this.policy = await fetch('/data/policy.html').then(r => r.text())
  },

  methods: {
    accept() {
      this.$emit('accept')
    },
    reject() {
      this.$emit('reject')
    },
    show() {
      this.visible = true
    },    
    hide() {
      this.visible = false
    }
  }
}
</script>

<style>
.privacy-policy {
  @apply text-sm overflow-y-scroll;
}
.privacy-policy h1, .privacy-policy h2 {
  @apply text-lg font-bold my-4;
}
.privacy-policy p {
  @apply mb-4;
}
.privacy-policy ol {
  @apply pl-4 my-4;
}
.privacy-policy ol li {
  list-style: decimal;
}
</style>